import {IMAGETYPE} from '@/utils/constants/saleTargetConstants';

export const MediaCardUiSchema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/title',
      component: 'textField',
      placeholder: 'Filename.png',
      label: 'Title',
      isDark: true
    },
    {
      type: 'Control',
      scope: '#/properties/imageId',
      component: 'dropdownControl',
      placeholder: '(Empty)',
      label: 'Image Type',
      className: 'text-sm w-full',
      isDark: true
    },
    {
      type: 'Control',
      scope: '#/properties/optIn',
      component: 'toggle',
      label: 'Opt In',
      size: 'medium',
      isDark: true
    }
  ]
};

export const mediaCardJsonSchema = {
  type: 'object',
  title: 'Display Content Media',
  properties: {
    title: {
      type: 'string'
    },
    imageId: {
      type: 'string',
      helperText: '',
      errorMessage: 'This field is required',
      options: [
        {
          id: IMAGETYPE.Foreground,
          displayText: IMAGETYPE.Foreground
        },
        {
          id: IMAGETYPE.Background,
          displayText: IMAGETYPE.Background
        }
      ],
      selectedValue: [
        {
          id: IMAGETYPE.Foreground,
          displayText: IMAGETYPE.Foreground
        }
      ]
    },
    optIn: {
      type: 'boolean'
    }
  },
  required: ['title', 'imageId']
};
